import React from 'react';
import {InputNumber} from 'antd';
import {InputMoneyProps} from '../../types/purchaseTypes';

// Some forms that call <InputMoney> may also pass in an onChange event handler
// in that case we need to use and pass in amount as a parameter. Components that
// do not use an event handler have to refer to value as to not erase the field on un-focusing.
const InputMoney = React.forwardRef<HTMLInputElement, InputMoneyProps>(
    ({onChange, amount, value, placeholder, disabled}, ref) => (
        <InputNumber
            precision={2}
            addonBefore="$"
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => {
                if (!value) return 0;
                const numberValue = parseFloat(value.replace(/\$\s?|(,*)/g, ''));
                return isNaN(numberValue) ? 0 : numberValue;
            }}
            value={amount === undefined ? value : amount}
            onChange={onChange as (value: number | null) => void}
            style={{width: '100%'}}
            placeholder={placeholder}
            disabled={disabled}
            ref={ref}
        />
    )
);

export default InputMoney;
